import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import {AiOutlineHome} from 'react-icons/ai';
import {BsPerson, BsCodeSlash} from 'react-icons/bs';
import {CgFileDocument} from 'react-icons/cg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBriefcase
} from '@fortawesome/free-solid-svg-icons';
import { FaMailBulk } from "react-icons/fa";
import { IoBookSharp } from "react-icons/io5";
import { FaProjectDiagram } from "react-icons/fa";

const Nav = () => {
    const [navbarblur, setnavbarblur]=useState(false);

    function scrollHandler() {
        if (window.scrollY >= 20) {
            setnavbarblur(true);
        } 
        else {
            setnavbarblur(false);
        }
    }

    var showMenu= ()=>{
        var bar=document.getElementsByClassName('bar');
        var ham=document.getElementsByClassName('NavbarLinks');
        bar[0].classList.toggle('barOne');
        bar[1].classList.toggle('barTwo');
        bar[2].classList.toggle('barThree');

        ham[0].classList.toggle('showNavbar');
    };

    var hideMenu = ()=>{
        var bar=document.getElementsByClassName('bar');
        var ham=document.getElementsByClassName('NavbarLinks');
        bar[0].classList.remove('barOne');
        bar[1].classList.remove('barTwo');
        bar[2].classList.remove('barThree');
        ham[0].classList.remove('showNavbar');
    };
    
    window.addEventListener('scroll', scrollHandler);

    return (
        <nav className={navbarblur? 'Navbar blur':'Navbar'}> 
 
            <h1 className='Logo'><Link style={{ textDecoration: 'none', color: 'white' }} to="/">DA.</Link></h1>

            <div className='Hamburger' onClick={showMenu}>
                <span className='bar'></span>
                <span className='bar'></span>
                <span className='bar'></span>
            </div>

            <ul className='NavbarLinks'>
                <li onClick={hideMenu}><Link to="/"><AiOutlineHome/> Home</Link></li>
                <li onClick={hideMenu}><Link to="/About"><BsPerson/> About</Link></li>
                <li onClick={hideMenu}><Link to="/skills"><BsCodeSlash/>Skills</Link></li>
                <li onClick={hideMenu}><Link to="/education"><IoBookSharp /> Education</Link></li>
                <li onClick={hideMenu}><Link to="/experience"><FontAwesomeIcon icon={faBriefcase} />Experience</Link></li>
                <li onClick={hideMenu}><Link to="/Project"><FaProjectDiagram /> Projects</Link></li>
                <li onClick={hideMenu}><Link to="/Resume"><CgFileDocument/> Resume</Link></li>
                <li onClick={hideMenu}><Link to="/contact"><FaMailBulk/>Get in Touch</Link></li>

            </ul>
        
        </nav>
    );
};

export default Nav;